export default {
    apiKey: "AIzaSyD9zRo8mhLIjXdJ8ncPks-8VLRyhRLZFcc",
    authDomain: "overwatch-tournament-manager.firebaseapp.com",
    databaseURL: "https://overwatch-tournament-manager.firebaseio.com",
    projectId: "overwatch-tournament-manager",
    storageBucket: "overwatch-tournament-manager.appspot.com",
    messagingSenderId: "803519250601"
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js